export default __webpack_public_path__ + "locales/ro/ChangePhoneDialog.json?hash=199c9a1670f3dbada75793a43c18a40f";